import NextImage from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useCallback, useRef, type FunctionComponent } from 'react'
import style from './SearchCard.module.sass'

type SearchCardProps = {
	name: string
	specification?: string
	url: string
	imageUrl?: string
	close: () => void
	type: 'blogPost' | 'item'
}

export const SearchCard: FunctionComponent<SearchCardProps> = ({ name, url, close, imageUrl, specification, type }) => {
	const router = useRouter()
	const routerRef = useRef(router)
	routerRef.current = router

	const onClick = useCallback(() => {
		close()
		routerRef.current.push(url)
	}, [close, url])

	return (
		<Link onClick={onClick} href={url} className={style.root} title={name}>
			<div className={style.card}>
				<div className={style.imageWrapper}>
					<div className={style.image}>
						<NextImage
							src={
								imageUrl ? imageUrl : type === 'item' ? '/images/placeholder.webp' : '/images/placeholder-article.jpg'
							}
							alt={name}
							title={name}
							layout="fill"
							objectFit={type === 'item' ? 'contain' : 'cover'}
						/>
					</div>
				</div>
				<div className={style.header}>
					<div className={style.title}>{name}</div>
					{specification && <p className={style.specification}>{specification}</p>}
				</div>
			</div>
		</Link>
	)
}
